import { createSelector } from 'reselect';

import { getWorkspace } from './getWorkspace';

export const getRobotPartIdsInScene = createSelector(
  getWorkspace,
  workspace => workspace.sceneRobotParts
);
